import React, { useEffect, useState } from "react";
import { getTransactionDetail } from "../../../api/DashboardInteractor";
import { useParams } from "react-router-dom";
import {
  formatDate,
  numberFormatWithoutSymbol,
  showToast,
  timeFormatNonUTC,
} from "../../../Utils";
import ConfirmationDialog from "../dialog/ConfirmationDialog";
import { apiCall } from "../../../api/Interactor";
import { useAppState } from '../../../AppStateContext';
import { FaWhatsapp } from "react-icons/fa";

function TransactionDetail(props) {
  const param = useParams();
  
  const { user, updateUser } = useAppState();

  let [isOpenConfirmPayment, setIsOpenConfirmPayment] = useState(false);
  let [isOpenCancelTransaction, setIsOpenCancelTransaction] = useState(false);
  let [note, setNote] = useState("");

  let [trxDetail, setTrxDetail] = useState({
    status: "",
    name: "",
    phone: "",
    email: "",
    sport_type: "",
    venue: "",
    booking_times: [
      {
        booking_date: "",
        booking_time: "",
      },
    ],
    package: "",
    session: 1,
    total_payment: 0,
    total_dp: 0,
    add_on_items: [],
    transactions: [
      {
        order_id: "",
        gateway_name: "",
        transaction_date: "",
        transaction_time: "",
        payment_url: null,
        package_unit: "",
        qty: 1,
        package_price: 0,
        discount: 0,
        service_fee: 0,
        admin_fee: 0,
        total: 0,
        is_dp: false,
      },
    ],
  });

  useEffect(() => {
    getDetailApi();
  }, []);

  const getDetailApi = () => {
    getTransactionDetail(
      param.trxId,
      (responseJSON) => {
        setTrxDetail(responseJSON);
        console.log("result trx detail ", responseJSON);
      },
      //failed
      (message) => {
        showToast("Error", "Get Detail Failed", message);
      }
    );
  };

  const cancelBooking = (transaction_id) => {
      apiCall(
        "POST", process.env.REACT_APP_VENUE_BOOKING_CANCEL,
        {
          transaction_id: transaction_id
        },
        (response) => {
          showToast("Success", "Cancel success")
          getDetailApi()
        },
        (message) => {
          showToast("Failed", "Cancel failed")
        }
      )
    }
  

  const printInvoice = () => {
    window.print();
  }

  const renderTrxPayment = () => {
    return trxDetail.transactions.map((trx) => {
      return (
        <div className="grid grid-cols-2 gap-4">
          <div className="">
            <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Order ID
            </p>
            <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
              {trx.order_id}
            </p>
          </div>

          <div>
            <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Metode Pembayaran
            </p>
            <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
              {trx.gateway_name}
            </p>
          </div>

          <div className="">
            <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Tanggal Transaksi
            </p>
            <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
              {formatDate(trx.transaction_date)}
            </p>
          </div>

          <div className="">
            <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Waktu Transaksi
            </p>
            <p className="rounded-br-lg text-gray-800 text-xs font-semibold tracking-widest ">
              {timeFormatNonUTC(trx.transaction_date + " " + trx.transaction_time + ":00")}
            </p>
          </div>

          <div className="">
            <p className="pb-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Status Transaksi
            </p>

            {trxDetail.status == "paid" ? (
              <div className="bg-[#87c816] flex h-fit w-fit items-center rounded-lg  px-4 py-1.5 text-white font-semibold text-[10px]">
                LUNAS
              </div>
            ) : ["unpaid", "unpaid_dp"].includes(trxDetail.status) ? (
              <div className="bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]">
                BELUM DIBAYAR
              </div>
            ) : ["waiting_for_payment"].includes(trxDetail.status) ? (
              <div className="bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]">
                WAITING FOR PAYMENT
              </div>
            )  : ["waiting_confirmation"].includes(trxDetail.status) ? (
              <div className="bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[9px]">
                WAITING CONFIRMATION
              </div>
            ) : trxDetail.status == "cancel" ? (
              <div className="bg-[#ca4e4e] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]">
                CANCEL
              </div>
            ) : (
              <div className="bg-[#ffaa00] flex h-fit w-fit items-center rounded-lg px-4 py-1.5 text-white font-semibold text-[10px]">
                {trxDetail.status}
              </div>
            )}
          </div>

          {trx.payment_url!==null&&(<div className="print:hidden">
            <p className="text-[12px] text-gray-700 font-semibold">
              Link Transaksi
            </p>
            <p className="flex items-center text-[12px] text-gray-700 font-semibold">
              <a href={trx.payment_url} target="blank">
                <button className="flex mt-2 items-center w-fit rounded-lg bg-primaryRed text-white px-4 py-1.5 text-[10px] font-semibold">
                  Open Link
                </button>
              </a>
            </p>
          </div>)}



          {trx.gateway_name==="PAYMENT ADMIN"&&(<div className="">
            <p className="pb-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
              Keterangan Pembayaran
            </p>

            <p className=" rounded-br-lg text-gray-600 text-xs font-semibold ">
              {trxDetail.note??"-"}
            </p>
          </div>)}
        </div>
      );
    });
  };

    const paymentConfirm = (transaction_id, note) => {
      apiCall(
        "POST", process.env.REACT_APP_VENUE_BOOKING_CONFIRM,
        {
          transaction_id: transaction_id,
          note: note,
        },
        (response) => {
          showToast("Success", "Confirmation success")
          getDetailApi()
        },
        (message) => {
          showToast("Failed", "Confirmation failed")
        }
      )
    }

    const openWhatsApp = (phone) => {
      if (phone.startsWith("0")) {
        phone = "62" + phone.slice(1);
      }
      window.open(`https://wa.me/${phone}`, "_blank");
    };

  return (
    <div className=" w-full bg-white rounded-2xl flex flex-col px-4 py-4 select-none">
      <p className="text-lg my-4 text-left text-gray-800 font-bold">
        Detail Transaksi
      </p>

      <div className="flex gap-4">
        {/* left pane */}
        <div className="w-1/2 flex flex-col gap-4">
          {/* informasi pesanan */}
          <div className="relative flex flex-col border border-gray-300 rounded-lg overflow-hidden pt-12 gap-x-6 px-4 pb-6">
            <p className="absolute left-0 top-0 px-3 bg-[#ececec] py-1.5 rounded-br-lg text-gray-800 text-xs font-semibold ">
              Informasi Pemesan
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Nama
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.name}
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Nomor Kontak
                </p>
                <p
                  className="rounded-br-lg text-green-600 text-xs font-semibold cursor-pointer flex items-center gap-1 print:text-gray-800"
                  onClick={() => openWhatsApp(trxDetail.phone)}
                >
                  <FaWhatsapp className="text-green-500 text-base print:hidden" />
                  <span>{trxDetail.phone}</span>
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Email
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.email}
                </p>
              </div>
            </div>
          </div>

          {/* detail pesanan */}
          <div className="relative flex flex-col border border-gray-300 rounded-lg overflow-hidden pt-12 gap-x-6 px-4 pb-6">
            <p className="absolute left-0 top-0 px-3 bg-[#ececec] py-1.5 rounded-br-lg text-gray-800 text-xs font-semibold ">
              Detail Pesanan
            </p>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Nama Venue
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.venue}
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Jenis Olahraga
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.sport_type}
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Tgl Booking
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.booking_times.length > 0 ? formatDate(trxDetail.booking_times[0].booking_date):""}
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Jam Booking
                </p>
                {trxDetail.booking_times.map((booking_time, idx) => (
                  <p key={idx} className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                    {booking_time.booking_time}
                  </p>
                ))}
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Jumlah Sesi
                </p>
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.session}
                </p>
              </div>

              <div>
                <p className="py-2 rounded-br-lg text-gray-600 text-xs font-semibold ">
                  Tambahan Add On
                </p>
                {trxDetail.add_on_items.map((item) => {
                  return (
                    <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                      {item.name}
                    </p>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="relative flex flex-col overflow-hidden pt-8 hidden print:block">
            <p className="text-black text-xs font-semibold italic">
              Jika ada pertanyaan mengenai pemesanan, dapat menghubungi :
            </p>
            <p className="text-black text-xs font-semibold italic mt-2">
              {user.name}
            </p>
            <p className="text-black text-xs font-semibold italic">
              {user.phone_number}
            </p>
          </div>
        </div>

        {/* right pane */}
        <div className="w-1/2 flex flex-col gap-4">
          {/* rincian transaksi*/}
          <div className="relative flex flex-col border border-gray-300 rounded-lg overflow-hidden pt-12 gap-x-6 px-4 pb-6">
            <p className="absolute left-0 top-0 px-3 bg-[#ececec] py-1.5 rounded-br-lg text-gray-800 text-xs font-semibold ">
              Rincian Transaksi
            </p>

            <div className="flex flex-col gap-y-4 divide-y divide-gray-300">
              {renderTrxPayment()}
            </div>

            <div className="flex flex-col gap-2">
              <div className="col-span-6 h-0.5 my-6 w-full bg-gray-200"></div>

              <p className=" rounded-br-lg text-gray-600 text-xs font-semibold ">
                Jam Booking{" "}
              </p>

              <div className="flex flex-col">
                <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {trxDetail.package}
                </p>

                {trxDetail.booking_times.map((booking_time, idx) => (
                  <div className="flex flex-row">
                  <p key={idx} className="rounded-br-lg text-gray-800 text-xs font-semibold flex">
                    {booking_time.booking_time}
                  </p>
                  <div className="flex flex-grow" />
                  <p key={idx} className="rounded-br-lg text-gray-800 text-xs font-semibold flex">
                    {"Rp. " +numberFormatWithoutSymbol(booking_time.price)}
                  </p>
                  </div>
                ))}
              </div>

              <p className="mt-4 rounded-br-lg text-gray-600 text-xs font-semibold ">
                Add On{" "}
              </p>

              {trxDetail.add_on_items.map((item) => {
                return (
                  <div className="flex justify-between">
                    <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                      {item.name + " (" + item.qty + ")"}
                    </p>
                    <p className="rounded-br-lg text-gray-800 text-xs font-semibold ">
                      {"Rp. " + numberFormatWithoutSymbol(item.total)}
                    </p>
                  </div>
                );
              })}

              <div className="col-span-6 h-0.5 my-6 w-full bg-gray-200"></div>

              {/* <div className="flex justify-between">
                <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
                  SUBTOTAL{" "}
                </p>
                <p className="w-1/4 text-right rounded-br-lg text-gray-800 text-xs font-semibold ">
                  Rp. {numberFormatWithoutSymbol(trxDetail.transactions[0].total)}
                </p>
              </div> */}
              <div className="flex justify-between">
                <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
                  DISKON LAPANG{" "}
                </p>
                <p className="w-1/4 text-right rounded-br-lg text-gray-800 text-xs font-semibold ">
                  - Rp. {numberFormatWithoutSymbol(trxDetail.transactions[0].discount)}
                </p>
              </div>
              <div className="flex justify-between">
                <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
                  DISKON PEMBAYARAN{" "}
                </p>
                <p className="w-1/4 text-right rounded-br-lg text-gray-800 text-xs font-semibold ">
                  - Rp. {numberFormatWithoutSymbol(trxDetail.transactions[0].pg_discount)}
                </p>
              </div>


              <div className="flex justify-between">
  <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
    BIAYA LAYANAN{" "}
  </p>
  <p className="w-1/4 text-right rounded-br-lg text-rose-600 text-xs font-semibold ">
    Rp. {numberFormatWithoutSymbol(trxDetail.transactions[0].service_fee)}
  </p>
</div>
<div className="flex justify-between">
  <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
    BIAYA ADMIN{" "}
  </p>
  <p className="w-1/4 text-right rounded-br-lg text-rose-600 text-xs font-semibold ">
    Rp. {numberFormatWithoutSymbol(trxDetail.transactions[0].admin_fee)}
  </p>
</div>

              <div className="flex justify-between">
                <p className="rounded-br-lg text-gray-600 text-xs font-semibold flex-grow text-right">
                  TOTAL BAYAR{" "}
                </p>
                <p className="w-1/4 text-right rounded-br-lg text-gray-800 text-xs font-semibold ">
                  {" "}
                  Rp. {numberFormatWithoutSymbol(trxDetail.total_payment)}
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-end print:hidden">
            {trxDetail.status === "waiting_for_payment" && (
            <button className="flex items-center w-fit rounded-lg my-4 bg-primaryRed text-white px-10 py-3 text-xs font-semibold" onClick={()=>{setIsOpenConfirmPayment(true)}}>
              Konfirmasi Pembayaran
            </button>
            )}
            {trxDetail.status !== "cancel" && (
            <button className="flex items-center w-fit rounded-lg ml-4 my-4 bg-primaryRed text-white px-10 py-3 text-xs font-semibold" onClick={()=>{setIsOpenCancelTransaction(true)}}>
              Batalkan Transaksi
            </button>)}
            <button className="flex items-center w-fit rounded-lg my-4 ml-4 bg-primaryRed text-white px-10 py-3 text-xs font-semibold" onClick={printInvoice}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6 mr-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z"
                />
              </svg>
              Cetak Invoice
            </button>
          </div>
        </div>
      </div>

<ConfirmationDialog 
title={"Konfirmasi"} 
message={"Konfirmasi pembayaran transaksi ini?"}
placeholderNote={"Keterangan pembayaran"}
note={note}
isOpen={isOpenConfirmPayment} 
onClose={()=>{
  setIsOpenConfirmPayment(false)
}} 
onConfirm={()=>{
  setIsOpenConfirmPayment(false)
  paymentConfirm(param.trxId, note)
}}
onNoteChange={(e)=>{
  setNote(e.target.value);
}}
 />

 <ConfirmationDialog 
 title={"Konfirmasi"} 
 message={"Batalkan transaksi ini?"}
 isOpen={isOpenCancelTransaction} 
 onClose={()=>{
   setIsOpenCancelTransaction(false)
 }} 
 onConfirm={()=>{
   setIsOpenCancelTransaction(false)
   cancelBooking(param.trxId)
 }}
  />

    </div>
  );
}

export default TransactionDetail;
